import { AfterViewInit, DestroyRef, Directive, inject, Input } from '@angular/core';
import { FacetValues } from '../../../pages/overview/models/overview';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { filter, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: 'mat-option[selectAll]',
  standalone: true
})
export class SelectAllFacetsDirective implements AfterViewInit {
  @Input({ required: true }) allValues: FacetValues[] = [];

  private matSelect = inject(MatSelect);
  private matOption = inject(MatOption);
  private destroyRef = inject(DestroyRef);

  ngAfterViewInit() {
    this.onOptionChanges();
    this.onSelectChanges();
  }

  unselect() {
    this.matOption.deselect(false);
  }

  private onOptionChanges() {
    this.matOption.onSelectionChange
      .pipe(
        tap(({ isUserInput, source }) => {
          const parentFormControl = this.matSelect.ngControl.control;
          if (isUserInput) {
            if (source.selected) {
              parentFormControl?.setValue(this.allValues.map(({ value }) => value));
              this.matOption.select(false);
            } else {
              parentFormControl?.setValue([]);
              this.matOption.deselect(false);
            }
          }
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  private onSelectChanges() {
    this.matSelect.optionSelectionChanges
      .pipe(
        filter(({ isUserInput, source }) => isUserInput && source.value !== this.matOption.value),
        tap(({ source }) => {
          if (!source.selected) {
            this.matOption.deselect(false);
          } else if (this.allOptionsAreSelected()) {
            this.matOption.select(false);
          }
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  private allOptionsAreSelected() {
    return this.matSelect.ngControl.control?.value.length === this.allValues.length;
  }
}
